"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../../container"));
var _kernel_store_types_1 = require("../../types");
var Playlist_1 = __importDefault(require("../../services/Playlist"));
var updatePlaylist_1 = __importDefault(require("./updatePlaylist"));
var player_1 = require("../../stores/player");
var regeneratePlaylist_1 = __importDefault(require("../generation/regeneratePlaylist"));
var sendPlayState_1 = __importDefault(require("../point/sendPlayState"));
var playlist_1 = require("../../selectors/playlist");
var global_1 = require("../../selectors/global");
var player_2 = require("../../selectors/player");
var lockPlaylistUpdateState_1 = __importDefault(require("./lockPlaylistUpdateState"));
function checkRequiredPlayState() {
    var action = function (dispatch, getState) {
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/checkRequiredPlayState");
        var state = getState();
        var _a = prereqsSelector(state), requiredPlayState = _a.requiredPlayState, currentPlayState = _a.currentPlayState;
        if (currentPlayState === requiredPlayState) {
            logger.debug("Play states are equal, skipping");
            return;
        }
        if ((0, player_2.selectPlaylistIsUpdating)(getState()) && requiredPlayState === _kernel_store_types_1.EPlayState.PLAY) {
            logger.debug("Playlist is now in update state, skipping");
            return;
        }
        var _b = selector(state), turnedOn = _b.turnedOn, shouldSleep = _b.shouldSleep, currentPlaylist = _b.currentPlaylist, currentTrackCached = _b.currentTrackCached, isConnected = _b.isConnected, isPlaybackLocked = _b.isPlaybackLocked;
        if (isPlaybackLocked) {
            logger.debug("Playback is locked");
            return;
        }
        logger.info("Checking required play state");
        if (!currentPlaylist.length) {
            logger.debug("Playlist length is too small, skipping..");
            return;
        }
        if (requiredPlayState === _kernel_store_types_1.EPlayState.PLAY) {
            if (!shouldSleep && turnedOn && (0, playlist_1.selectPlaylistLength)(getState()) > 0) {
                logger.info("Cropping playlist up to correct playtime");
                var croppedPlaylist = Playlist_1.default.correctPlaylistUpToPlaytime(currentPlaylist);
                if (croppedPlaylist.length !== currentPlaylist.length) {
                    dispatch((0, lockPlaylistUpdateState_1.default)(true));
                    dispatch((0, updatePlaylist_1.default)(croppedPlaylist));
                }
                if ((0, playlist_1.selectPlaylistLength)(getState()) > 0) {
                    if (!(0, player_2.selectPlaylistIsUpdating)(getState())) {
                        if (!isConnected && !currentTrackCached) {
                            logger.warn("Uncached playback in offline is not supported, skipping..");
                        }
                        else {
                            dispatch((0, player_1.setCurrentPlayState)(requiredPlayState));
                        }
                    }
                }
                else {
                    logger.warn("Playlist is empty after cropping up to playtime, regenerating..");
                    dispatch((0, regeneratePlaylist_1.default)());
                }
            }
        }
        else {
            dispatch((0, player_1.setCurrentPlayState)(requiredPlayState));
        }
        dispatch((0, sendPlayState_1.default)());
        dispatch({ type: checkRequiredPlayState.type });
    };
    action.type = checkRequiredPlayState.type;
    return action;
}
function prereqsSelector(state) {
    return {
        requiredPlayState: (0, player_2.selectRequiredPlayState)(state),
        currentPlayState: (0, player_2.selectCurrentPlayState)(state),
    };
}
function selector(state) {
    return {
        currentPlaylist: (0, playlist_1.selectPlaylistItems)(state),
        requiredPlayState: (0, player_2.selectRequiredPlayState)(state),
        currentPlayState: (0, player_2.selectCurrentPlayState)(state),
        shouldSleep: (0, global_1.selectShouldSleep)(state),
        turnedOn: (0, global_1.selectTurnedOn)(state),
        isConnected: (0, global_1.selectIsConnected)(state),
        currentTrackCached: (0, playlist_1.selectCurrentTrackIsCached)(state),
        isPlaybackLocked: (0, global_1.selectIsPlaybackLocked)(state),
    };
}
checkRequiredPlayState.type = "checkRequiredPlayState";
exports.default = checkRequiredPlayState;
//# sourceMappingURL=checkRequiredPlayState.js.map